// extracted by mini-css-extract-plugin
export default {"sideNav":"sideNav__x3p1x","active":"active__lwSsu"};